import { render, staticRenderFns } from "./Bouton.vue?vue&type=template&id=dbd76796&"
import script from "./Bouton.vue?vue&type=script&lang=js&"
export * from "./Bouton.vue?vue&type=script&lang=js&"
import style0 from "./Bouton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports